export default __webpack_public_path__ + "static/media/wsn.49f9983a.png";